export default "__VITE_ASSET__DCEorPyA__"